import React from "react";
import "./CoverLetterComponent.css";

const CoverLetterComponent = () => {
  return (
    <div className="cover-letter-component__root">
      <span className="cover-letter-component__name">Baris SECKIN</span>
      <span className="cover-letter-component__title">
        ~Java Backend Developer
      </span>
      <span className="cover-letter-component__content">
        Hello, I’m Baris. I continue to improve myself on Java and the technologies it brings. 
        I am constantly trying to produce new projects. I enjoy doing research and learning new things.
      </span>
    </div>
  );
};

export default CoverLetterComponent;
